import { render, staticRenderFns } from "./dictItem.vue?vue&type=template&id=194b061d&scoped=true"
import script from "./dictItem.vue?vue&type=script&lang=js"
export * from "./dictItem.vue?vue&type=script&lang=js"
import style0 from "./dictItem.vue?vue&type=style&index=0&id=194b061d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194b061d",
  null
  
)

export default component.exports